import React from "react";

interface RefreshIntervalContextType {
  refreshInterval: number;
  setRefreshInterval: (interval: number) => void;
}

const RefreshIntervalContext = React.createContext<RefreshIntervalContextType>({
  refreshInterval: 10,
  setRefreshInterval: () => {},
});

export const RefreshIntervalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [refreshInterval, setRefreshIntervalState] = React.useState<number>(() => {
    // Load from localStorage on mount
    const saved = localStorage.getItem('priceTableRefreshInterval');
    return saved ? Number(saved) : 10;
  });

  const setRefreshInterval = React.useCallback((interval: number) => {
    setRefreshIntervalState(interval);
    localStorage.setItem('priceTableRefreshInterval', interval.toString());
  }, []);

  const value = React.useMemo(
    () => ({
      refreshInterval,
      setRefreshInterval,
    }),
    [refreshInterval, setRefreshInterval]
  );

  return (
    <RefreshIntervalContext.Provider value={value}>
      {children}
    </RefreshIntervalContext.Provider>
  );
};

export const useRefreshInterval = () => {
  const context = React.useContext(RefreshIntervalContext);
  if (!context) {
    throw new Error('useRefreshInterval must be used within RefreshIntervalProvider');
  }
  return context;
};

export default RefreshIntervalContext;
